module.exports = __webpack_public_path__ + "img/activity-bg.11fbabf8.png";